import $ from 'jquery';
import 'core-js/es/array';


var $navOpenButton = $('.btn-nav-toggle');

$navOpenButton.on('click', (e) => {
	$('body').toggleClass('no-scroll');
	$('.nav-wrapper').toggleClass('nav-open');

	e.preventDefault();
});

// Prevent first level buttons with dropdown to link
$("#MainNavigation > .nav > .dropdown > a").click(function (e) {
	e.preventDefault()
});

// if Swiss Light Creation page
if(document.querySelector('body#slc')) {

	// to all links with hash param (#) add 'shortcut-param' class
	var elems = Array.from(document.querySelectorAll('#accordion-content a'));
	elems.forEach((itm, i) => {
		if(itm.hash) {
			itm.classList.add('shortcut-param');
		}
	});

	// animate scroll on 'shortcut-param' link click
	$(".shortcut-param").click(function(e) {
		e.preventDefault();
		$('body').removeClass('no-scroll');
		var indx = $(this).parent().index() - 1;
		var top = $(window).width() >= 768 ? $(e.target.hash).offset().top : $("#accordion").offset().top + (indx * 80) - 80;
		switchAccordion(indx, top, e.target.hash);

		// make active link in Main Nav dropdown
		menuElems.forEach((itm,i) => {
			itm.parentElement.classList.remove('current', 'active');
			if(itm.hash === e.target.hash) {
				itm.parentElement.classList.add('active');
			}
		});
	});
}

function switchAccordion(indx = 0, top = 0, hash = '') {
	// cloase all accordions
	$("#accordion .card .card-header button").attr('class', 'btn btn-link collapsed');
	$("#accordion .card > .collapse").attr('class', 'collapse');

	// open by index
	$("#accordion .card:eq("+indx+") > .card-header button").attr('class', 'btn btn-link');
	$("#accordion .card:eq("+indx+") > .collapse").attr('class', 'collapse show');

	// close menu if open
	if($('.nav-wrapper').hasClass('nav-open')) {
		$('.nav-wrapper').removeClass('nav-open');
	}

	// animate scroll
	$('html, body').stop().animate({
		scrollTop: top
	}, 750, function() {
		location.hash = hash;
	});
}
